import React from "react";

function EditIcon({ disabled = false, fill}) {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.3538 3.64628L12.3538 1.64628C12.3073 1.59979 12.2522 1.56291 12.1915 1.53775C12.1308 1.51258 12.0657 1.49963 12 1.49963C11.9343 1.49963 11.8692 1.51258 11.8085 1.53775C11.7478 1.56291 11.6927 1.59979 11.6462 1.64628L5.64625 7.64628C5.59983 7.69275 5.56303 7.7479 5.53793 7.8086C5.51284 7.8693 5.49995 7.93435 5.5 8.00003V10C5.5 10.1326 5.55268 10.2598 5.64645 10.3536C5.74021 10.4473 5.86739 10.5 6 10.5H8C8.06568 10.5001 8.13073 10.4872 8.19143 10.4621C8.25212 10.437 8.30728 10.4002 8.35375 10.3538L14.3538 4.35378C14.4002 4.30734 14.4371 4.2522 14.4623 4.1915C14.4874 4.1308 14.5004 4.06573 14.5004 4.00003C14.5004 3.93432 14.4874 3.86926 14.4623 3.80856C14.4371 3.74786 14.4002 3.69271 14.3538 3.64628ZM7.79313 9.50003H6.5V8.2069L10.5 4.2069L11.7931 5.50003L7.79313 9.50003ZM12.5 4.79315L11.2069 3.50003L12 2.7069L13.2931 4.00003L12.5 4.79315ZM14 8.00003V13C14 13.2652 13.8946 13.5196 13.7071 13.7071C13.5196 13.8947 13.2652 14 13 14H3C2.73478 14 2.48043 13.8947 2.29289 13.7071C2.10536 13.5196 2 13.2652 2 13V3.00003C2 2.73481 2.10536 2.48046 2.29289 2.29292C2.48043 2.10538 2.73478 2.00003 3 2.00003H8C8.13261 2.00003 8.25979 2.05271 8.35355 2.14647C8.44732 2.24024 8.5 2.36742 8.5 2.50003C8.5 2.63264 8.44732 2.75981 8.35355 2.85358C8.25979 2.94735 8.13261 3.00003 8 3.00003H3V13H13V8.00003C13 7.86742 13.0527 7.74024 13.1464 7.64647C13.2402 7.55271 13.3674 7.50003 13.5 7.50003C13.6326 7.50003 13.7598 7.55271 13.8536 7.64647C13.9473 7.74024 14 7.86742 14 8.00003Z"
          fill={disabled ? "#9CA3AF" : fill}
        />
      </svg>
    </>
  );
}

export default EditIcon;
